/**
 * DooDatesLogo - Composant pour afficher le logo DooDates
 * Utilisé dans les pages de vote/résultats si poll.settings.showLogo === true
 * Supporte les logos spécifiques par produit + logo DooDates générique
 */

interface DooDatesLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  product?: "date" | "form" | "quizz" | "availability" | "landing";
}

export function DooDatesLogo({
  className = "",
  size = "md",
  product = "landing",
}: DooDatesLogoProps) {
  const sizeClasses = {
    sm: "h-6",
    md: "h-8",
    lg: "h-10",
  };

  // Déterminer le chemin du logo selon le produit
  const getLogoPath = () => {
    const logos = {
      date: "/logo-date-polls.svg",
      form: "/logo-form-polls.svg",
      quizz: "/logo-quizz.svg",
      availability: "/logo-availability-polls.svg",
      landing: "/logo-doodates.svg",
    };
    return logos[product] || logos.landing;
  };

  // Déterminer le texte selon le produit
  const getTagline = () => {
    const taglines = {
      date: "Planifiez vos dates",
      form: "Créez vos formulaires",
      quizz: "Testez vos connaissances",
      availability: "Vérifiez vos disponibilités",
      landing: "Créé avec DooDates",
    };
    return taglines[product] || taglines.landing;
  };

  const logoPath = getLogoPath();
  const tagline = getTagline();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <img
          src={logoPath}
          alt={product === "form" ? "DooQuest" : "DooDates"}
          className={`${sizeClasses[size]} w-auto hidden dark:block`}
        />
        <img
          src={logoPath.replace(".svg", "-dark.svg")}
          alt={product === "form" ? "DooQuest" : "DooDates"}
          className={`${sizeClasses[size]} w-auto block dark:hidden`}
        />
      </div>
      <span className="text-sm text-gray-500 dark:text-gray-400">
        {tagline}
      </span>
    </div>
  );
}
